import React from 'react';
import { useDrawers } from '../../contexts/DrawerContext';
import { Button } from '../ui/Button';
const STEPS = [{
  num: '01',
  title: 'Send the details',
  desc: 'Tell us whether you are buying, selling or reviewing a contract. Upload documents where relevant.'
}, {
  num: '02',
  title: 'Confirm scope and timing',
  desc: 'The team reviews the matter, identifies deadlines and explains the proposed scope and fee.'
}, {
  num: '03',
  title: 'Review and advice',
  desc: 'Relevant documents, conditions and transaction risks are considered and explained.'
}, {
  num: '04',
  title: 'Transaction management',
  desc: 'The team coordinates documents, parties, dates and settlement requirements.'
}, {
  num: '05',
  title: 'Settlement and confirmation',
  desc: 'You are kept informed as the matter reaches settlement and completion.'
}];
export function Process() {
  const {
    openUpload
  } = useDrawers();
  return <section className="py-10 md:py-14 px-5 md:px-6 bg-cream" data-id="element-297" data-mp="3496s38btmcnb">
      <div className="max-w-7xl mx-auto" data-id="element-298" data-mp="34ahv35xfzgdd">
        <div className="max-w-2xl mb-6 md:mb-8" data-id="element-299" data-mp="2zadab3pi3zhc">
          <p className="eyebrow text-brand-blue mb-1" data-id="element-300" data-mp="2z8is3x5m6lgy">
            no surprises
          </p>
          <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-301" data-mp="2ubivecunmv2i">
            A clear process from first contact to settlement.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3" data-id="element-302" data-mp="3n07qnv91466c">
          {STEPS.map(step => <div key={step.num} className="relative h-full rounded-2xl bg-surface border border-border p-5 flex flex-col" data-id="element-303" data-mp="3i1mohqa7vcf9">
              <span className="font-serif text-3xl text-accent/30" data-id="element-304" data-mp="398jclmf7z7mq">
                {step.num}
              </span>
              <div className="my-4 h-px w-10 bg-accent/40" data-id="element-305" data-mp="9lb9s99nxcnn" />
              <h3 className="font-serif text-xl text-ink mb-2" data-id="element-306" data-mp="9mmgaguhsyig">{step.title}</h3>
              <p className="text-sm text-muted-ink leading-relaxed" data-id="element-307" data-mp="4srzbl69uxn2">
                {step.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 border-y border-border bg-surface p-5 md:p-6" data-id="element-308" data-mp="2419qt0o28qbq">
          <p className="text-ink text-lg flex-1" data-id="element-309" data-mp="1pbkk6px77u42">
            Ready to begin? The fastest first step is to send the contract.
          </p>
          <Button onClick={openUpload} variant="accent" size="lg" data-id="element-310" data-mp="1gbfimweorpxt">
            Upload a contract
          </Button>
        </div>
      </div>
    </section>;
}